import React, { useEffect, useState } from "react";
import "../assets/css/mobilepopup.css";

const Popup = ({
  isOpen,
  onClose,
  onConfirm,
  questionText = "",
  mode = "score",       // ✅ NEW: tells popup if it's score or target
  initialValue = 1,
  options = [
    { value: 1, text: "Is it in somebody's head?" },
    { value: 2, text: "Is it written down and formally agreed?" },
    { value: 3, text: "Is it measured against an organisational objective?" },
    { value: 4, text: "Is it optimised?" },
  ],
}) => {
  const [selected, setSelected] = useState(initialValue);

  useEffect(() => {
    if (isOpen) setSelected(initialValue);
  }, [isOpen, initialValue]);

  if (!isOpen) return null;

  // ✅ Dynamic colors based on mode
  const highlightColor = mode === "score" ? "#7C8C27" : "#725581";
  const labelText = mode === "score" ? "Score" : "Target";

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        {/* ✅ Close button */}
        <button className="popup-close" onClick={onClose}>
          ✕
        </button>

        {/* ✅ Question text */}
        <p className="popup-question-text">{questionText}</p>

        {/* ✅ Score/Target label */}
        <p className="popup-mode-label" style={{ color: highlightColor }}>
          {labelText}
        </p>

        {/* ✅ Rating options */}
        <div className="popup-options">
          {options.map((opt) => (
            <label
              key={opt.value}
              className={`popup-option-row ${
                selected === opt.value ? "active" : ""
              }`}
             style={{
  "--highlight-color": highlightColor   // ✅ pass color to CSS
}}

            >
              {/* Text */}
              <div className="popup-option-text">
                <span className="popup-option-number">{opt.value}</span>
                <span className="popup-option-desc">{opt.text}</span>
              </div>

              {/* ✅ Radio button on RIGHT */}
              <input
                type="radio"
                className="popup-radio"
                name="rating"
                checked={selected === opt.value}
                style={{ accentColor: highlightColor }}
                onChange={() => setSelected(opt.value)}
              />
            </label>
          ))}
        </div>

        {/* ✅ Select button */}
        <div className="popup-footer">
          <button
            className="popup-select"
            // style={{ background: highlightColor }}
            onClick={() => {
              onConfirm(selected);
              onClose();
            }}
          >
            Select
          </button>
        </div>

      </div>
    </div>
  );
};

export default Popup;
